<template>
  <div>
    <Row type="flex" justify="center">
      <Col :span="16">
        <div class="box">
          <Row type="flex">
            <Col :span="2" v-for="(card,i) in cardList" :key="i" style="margin:10px;width:220px;height:130px;margin-left:28px;">
              <div class="bank_card_box" @click="unbounding(card,i)" v-bind:class="{bandColor1:true,bandColor2:rowNo===i?true:false}">
                <div class="bank_name">
                  <div style="background:#dddee1;height:40px;line-height:40px;text-align:center;font-size:18px;font-weight:bold;">
                    <span v-if="card.name == null">{{card.name}}</span>
                    <span v-if="card.name != null">{{`${card.name.slice(0,6)}**`}}</span>
                  </div>
                </div>
                <div class="ivu-tooltip-content" style="display:flex;">
                  <span style="font-size:14px;">尾号{{card.cardNo | cardSlice}}</span>
                  <div style="background:#7DAECB;width:40px;height:20px;color:#ffffff;margin-left:5px;text-align:center;border-radius: 10%">{{card.bankType === '对公'?'对公':'对私'}}</div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div class="b_button_group">
          <my-button @confirm="() => {this.$router.go(-1)}">返回</my-button>
          <div class="box_right" @click="onSubmit('form')"><my-button>解除绑定</my-button></div>
        </div>
      </Col>
    </Row>
    <Modal
      v-model="modal2" @keyup.enter.native="submit">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="information-circled"></Icon>
        <span>支付密码</span>
      </p>
      <template v-if="modal2">
        <password-input v-model="value" @input="password"></password-input>
      </template>
      <div slot="footer" style="display: flex;justify-content: center" >
        <my-button @confirm="submit">确定</my-button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import ApiClient from '@/api/ApiClient'
  import MyButton from '@/components/MyButton'
  import passwordInput from '@/components/passwordInput'
  export default {
    components: {MyButton,passwordInput},
    name: "unbundingBankCard",
    data() {
      return {
        modal2: false,
        value: '',
        rowNo:'',
        information:{
          customerId:'',
          bankCardId:'',
          bankName: '',
          bankType: '',
          cardNo: '',
          cashPassword: '',
          customerName: '',
          operChar:1
        },
        cardList:[],
        card:{
          bankName:'',
          cardNo:'',
        }
      }
    },
    mounted() {
      this.information.bankName = this.$route.query.bankName;
      this.information.bankCardId  = this.$route.query.bankCardId;
      this.information.cardNo = this.$route.query.cardNo;
      this.information.bankType = this.$route.query.bankType;
      this.information.cashPassword = this.$route.query.cashPassword;
      this.information.customerName =this.$route.query.customerName;
      this.information.customerId = this.$route.query.customerId;
    },
    methods:{
      onSubmit() {
        if(this.rowNo ===''){
          this.$Message.error('请选择银行卡')
          return;
        }else{
          this.modal2 = true;
          this.value = ''
        }
      },
      submit() {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确定解除绑定银行卡</p>',
          onOk: () => {
            this.information.customerId=JSON.parse(sessionStorage.getItem('currentUser')).userId
            ApiClient.post('/desktop/profile/cardManage.do',this.information).then(data=>{
              this.$router.go(-1)
            })
          },
        });
        if(this.value.length===6){
          this.modal2 = false;
        }
      },
      password(value) {
        this.information.cashPassword = value;
      },
      initData() {
        ApiClient.post('/desktop/profile/cardQuery.do', {size: 9999, page: 1}).then(data => {
          this.cardList = data.wCardQueryDataDtoList;
          this.card = this.cardList[0];
          this.information.cardNo = this.card.cardNo;
        });
      },
      unbounding(card,i) {
        this.information.bankCardId=card.bankCardId;
        this.information.bankName=card.bankName;
        this.information.cardNo=card.cardNo;
        this.information.bankType=card.bankType;
        this.information.customerName=card.customerName;
        this.rowNo = i;
      },
    },
    mounted() {
      this.initData();
    },
  }
</script>
<style scoped lang="less">
  .bank_card_box {
    border: 1px solid red;
    padding: 20px 20px;
    cursor: pointer;
  }
  .box {
    border: 1px solid #999;
    margin:0 auto;
    .box_left{
      float: left;
    }
    .box_right{
      float: right;
      cursor: pointer;
    }
    .bank_name {
      margin-bottom: 20px;
      font-size: 25px;
      color: #000;
    }
    .card_no{font-size: 15px}
    .bandColor1{
      border:2px solid #ddd;
      margin: 0 auto;
      display: block;
    }
    .bandColor2{
      border:2px solid #228b22;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/myProfile/unbundingBankCard.vue